import React from "react";

type IconProps = React.SVGAttributes<SVGElement>;

export const MetamaskIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 397 355" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(-1 -1)">
      <path
        d="m114.622644 327.195472 52.004717 13.810198v-18.05949l4.245283-4.249292h29.716982v21.246459 14.872523h-31.839624l-39.268868-16.997169z"
        fill="#cdbdb2"
      />
      <path
        d="m199.528305 327.195472 50.943397 13.810198v-18.05949l4.245283-4.249292h29.716981v21.246459 14.872523h-31.839623l-39.268868-16.997169z"
        fill="#cdbdb2"
        transform="matrix(-1 0 0 1 483.96227 0)"
      />
      <path
        d="m170.872644 287.889523-4.245283 35.056657 5.306604-4.249292h55.18868l6.367925 4.249292-4.245284-35.056657-8.490565-5.311615-42.452832 1.062323z"
        fill="#393939"
      />
      <path
        d="m142.216984 50.9915022 25.471698 59.4900858 11.674528 173.158643h41.391511l12.735849-173.158643 23.349056-59.4900858z"
        fill="#f89c35"
      />
      <path
        d="m30.7783023 181.657226-29.71698153 86.048161 74.29245393-4.249293h47.7594343v-37.181303l-2.122641-76.487253-10.613208 8.498583z"
        fill="#f89d35"
      />
      <path
        d="m87.0283032 191.218134 87.0283028 2.124646-9.551886 44.617563-41.391511-10.623229z"
        fill="#d87c30"
      />
      <path
        d="m87.0283032 192.280457 36.0849058 33.994334v33.994334z"
        fill="#ea8d3a"
      />
      <path
        d="m123.113209 227.337114 42.452831 10.623229 13.79717 45.679888-9.551886 5.311615-46.698115-27.620398z"
        fill="#f89d35"
      />
      <path
        d="m123.113209 261.331448-8.490565 65.864024 56.25-39.305949z"
        fill="#eb8f35"
      />
      <path
        d="m174.056606 193.34278 5.306604 90.297451-15.919812-46.211049z"
        fill="#ea8e3a"
      />
      <path
        d="m74.2924539 262.393771 48.8207551-1.062323-8.490565 65.864024z"
        fill="#d87c30"
      />
      <path
        d="m24.4103777 355.878193 90.2122663-28.682721-40.3301901-64.801701-73.23113313 5.311616z"
        fill="#eb8f35"
      />
      <path
        d="m167.688682 110.481588-45.636793 38.243627-35.0235858 42.492919 87.0283028 3.186969z"
        fill="#e8821e"
      />
      <path
        d="m114.622644 327.195472 56.25-39.305949-4.245283 33.994334v19.121813l-38.207548-7.43626z"
        fill="#dfcec3"
      />
      <path
        d="m229.245286 327.195472 55.18868-39.305949-4.245283 33.994334v19.121813l-38.207548-7.43626z"
        fill="#dfcec3"
        transform="matrix(-1 0 0 1 513.679252 0)"
      />
      <path
        d="m132.665096 212.464593-11.674528 24.433427 41.39151-10.623229z"
        fill="#393939"
        transform="matrix(-1 0 0 1 283.372646 0)"
      />
      <path
        d="m23.349057 1.06232296 144.339625 109.41926504-24.410378-59.4900858z"
        fill="#e88f35"
      />
      <path
        d="m23.349057 1.06232296-19.10377392 58.42776294 10.61320772 63.7393781-7.42924541 4.249292 10.61320771 9.560906-8.49056617 7.436261 11.67452847 10.623229-7.4292454 6.373938 16.9811323 21.246459 79.5990577-24.433428c38.915096-31.161473 58.018869-47.096318 57.311322-47.804533-.707548-.708215-48.820756-37.1813036-144.339625-109.41926504z"
        fill="#8e5a30"
      />
      <g transform="matrix(-1 0 0 1 399.056611 0)">
        <path
          d="m30.7783023 181.657226-29.71698153 86.048161 74.29245393-4.249293h47.7594343v-37.181303l-2.122641-76.487253-10.613208 8.498583z"
          fill="#f89d35"
        />
        <path
          d="m87.0283032 191.218134 87.0283028 2.124646-9.551886 44.617563-41.391511-10.623229z"
          fill="#d87c30"
        />
        <path
          d="m87.0283032 192.280457 36.0849058 33.994334v33.994334z"
          fill="#ea8d3a"
        />
        <path
          d="m123.113209 227.337114 42.452831 10.623229 13.79717 45.679888-9.551886 5.311615-46.698115-27.620398z"
          fill="#f89d35"
        />
        <path
          d="m123.113209 261.331448-8.490565 65.864024 55.18868-38.243626z"
          fill="#eb8f35"
        />
        <path
          d="m174.056606 193.34278 5.306604 90.297451-15.919812-46.211049z"
          fill="#ea8e3a"
        />
        <path
          d="m74.2924539 262.393771 48.8207551-1.062323-8.490565 65.864024z"
          fill="#d87c30"
        />
        <path
          d="m24.4103777 355.878193 90.2122663-28.682721-40.3301901-64.801701-73.23113313 5.311616z"
          fill="#eb8f35"
        />
        <path
          d="m167.688682 110.481588-45.636793 38.243627-35.0235858 42.492919 87.0283028 3.186969z"
          fill="#e8821e"
        />
        <path
          d="m132.665096 212.464593-11.674528 24.433427 41.39151-10.623229z"
          fill="#393939"
          transform="matrix(-1 0 0 1 283.372646 0)"
        />
        <path
          d="m23.349057 1.06232296 144.339625 109.41926504-24.410378-59.4900858z"
          fill="#e88f35"
        />
        <path
          d="m23.349057 1.06232296-19.10377392 58.42776294 10.61320772 63.7393781-7.42924541 4.249292 10.61320771 9.560906-8.49056617 7.436261 11.67452847 10.623229-7.4292454 6.373938 16.9811323 21.246459 79.5990577-24.433428c38.915096-31.161473 58.018869-47.096318 57.311322-47.804533-.707548-.708215-48.820756-37.1813036-144.339625-109.41926504z"
          fill="#8e5a30"
        />
      </g>
    </g>
  </svg>
);

export const WalletConnectIcon: React.FC<IconProps> = (props) => (
  <svg
    height="246"
    viewBox="0 0 400 246"
    width="400"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m81.9180572 48.3416816c65.2149658-63.8508884 170.9493158-63.8508884 236.1642788 0l7.848727 7.6845565c3.260748 3.1925442 3.260748 8.3686816 0 11.5612272l-26.848927 26.2873374c-1.630375 1.5962734-4.273733 1.5962734-5.904108 0l-10.800779-10.5748639c-45.495589-44.5439756-119.258514-44.5439756-164.754105 0l-11.566741 11.3248068c-1.630376 1.5962721-4.273735 1.5962721-5.904108 0l-26.8489263-26.2873375c-3.2607483-3.1925456-3.2607483-8.3686829 0-11.5612272zm291.6903948 54.3649934 23.895596 23.395862c3.260732 3.19253 3.260751 8.368636.000041 11.561187l-107.746894 105.494845c-3.260726 3.192568-8.547443 3.192604-11.808214.000083-.000013-.000013-.000029-.000029-.000042-.000043l-76.472191-74.872762c-.815187-.798136-2.136867-.798136-2.952053 0-.000006.000005-.00001.00001-.000015.000014l-76.470562 74.872708c-3.260715 3.192576-8.547434 3.19263-11.808215.000116-.000019-.000018-.000039-.000037-.000059-.000058l-107.74989297-105.496247c-3.26074695-3.192544-3.26074695-8.368682 0-11.561226l23.89563947-23.395823c3.260747-3.1925446 8.5474652-3.1925446 11.8082136 0l76.4733029 74.873809c.815188.798136 2.136866.798136 2.952054 0 .000012-.000012.000023-.000023.000035-.000032l76.469471-74.873777c3.260673-3.1926181 8.547392-3.1927378 11.808214-.000267.000046.000045.000091.00009.000135.000135l76.473203 74.873909c.815186.798135 2.136866.798135 2.952053 0l76.471967-74.872433c3.260748-3.1925458 8.547465-3.1925458 11.808213 0z"
      fill="#3b99fc"
    />
  </svg>
);

export const WalletLinkIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <circle id="a" cx="59.928" cy="59.928" r="59.928" />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="c">
        <stop stopColor="#2E66F8" offset="0%" />
        <stop stopColor="#124ADB" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        className="outerBackground"
        fill="#Fff"
        fillRule="nonzero"
        d="M0 0h128v128H0z"
      />
      <path
        className="outerBackground"
        fill="#FFF"
        fillRule="nonzero"
        d="M0 0h128v128H0z"
      />
      <path d="M0 0h128v128H0z" />
      <path
        d="M19 64c0 24.853 20.147 45 45 45s45-20.147 45-45-20.147-45-45-45-45 20.147-45 45zm33.5-14.5a3 3 0 0 0-3 3v23a3 3 0 0 0 3 3h23a3 3 0 0 0 3-3v-23a3 3 0 0 0-3-3h-23z"
        fill="#FFF"
      />
      <g transform="translate(4 4)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <g mask="url(#b)">
          <path d="M0 0h119.856v119.856H0z" />
          <rect
            fill="url(#c)"
            fillRule="nonzero"
            width="119.856"
            height="119.856"
            rx="48"
          />
          <path
            className="innerBackground"
            d="M24.97 59.928c0 19.307 15.651 34.958 34.958 34.958s34.958-15.651 34.958-34.958S79.235 24.97 59.928 24.97 24.97 40.62 24.97 59.928zm26.024-11.264a2.33 2.33 0 0 0-2.33 2.33v17.868a2.33 2.33 0 0 0 2.33 2.33h17.868a2.33 2.33 0 0 0 2.33-2.33V50.994a2.33 2.33 0 0 0-2.33-2.33H50.994z"
            fill="#FFF"
          />
        </g>
      </g>
    </g>
  </svg>
);
